module.exports = __webpack_public_path__ + "static/media/plus.f75972cc.svg";